const AU_PREFIX = '+61';
export const AU_SUBSCRIBER_LENGTH = 9;

export const extractSubscriberDigits = (raw: string): string => {
  const digits = raw.replace(/\D/g, '');
  let national = digits;
  if (national.startsWith('61')) national = national.slice(2);
  else if (national.startsWith('0')) national = national.slice(1);
  return national.slice(0, AU_SUBSCRIBER_LENGTH);
};

export const formatAuMobile = (raw: string): string => {
  const subscriber = extractSubscriberDigits(raw);
  if (!subscriber) return '';

  const groups = [
    subscriber.slice(0, 3),
    subscriber.slice(3, 6),
    subscriber.slice(6, 9),
  ].filter(Boolean);

  return `${AU_PREFIX} ${groups.join(' ')}`;
};

export const toE164AuMobile = (formatted: string): string =>
  formatted.replace(/\s/g, '');

// `0XXXXXXXXX` (AU national format) — required by the user-profile BE,
// which validates the phone number against `^04\d{8}$`.
export const toAuNationalMobile = (formatted: string): string => {
  const subscriber = extractSubscriberDigits(formatted);
  return subscriber ? `0${subscriber}` : '';
};
